import { type FC } from 'react';
import ChevronRightIcon from '@assets/img/icons/chevron-right-square.svg?react';
import { type ProductData } from '@common/types/workshopType';
import { H2 } from '@components/Typography/Typography';
import { Scale } from '@components/ui/Scale/Scale';

import css from './styles.module.scss';

interface WorkshopProductionPreviewProps {
  activeGoods?: ProductData;
  localStock?: number;
  incommingStorage?: number;
  className?: string;
  producted: number;
}

const WorkshopProductionPreview: FC<WorkshopProductionPreviewProps> = ({
  activeGoods,
  localStock,
  incommingStorage,
  producted,
}) => {
  return (
    <div className="flex flex-col gap-2 flex-1 relative z-[5]">
      <div className="flex items-center justify-between">
        <H2 weight="bold" className="!leading-none">
          {(localStock || 0) + producted}
        </H2>
        <ChevronRightIcon className="w-5 h-5 shink-0" />
      </div>
      <Scale
        className={css.scale}
        height={8}
        percentage={
          activeGoods?.storageCapacity
            ? (((localStock || 0) + producted) * 100) /
              activeGoods.storageCapacity
            : 0
        }
        additionalTrack={{
          percentage: activeGoods?.storageCapacity
            ? (((localStock || 0) + (incommingStorage || 0)) * 100) /
              activeGoods.storageCapacity
            : 0,
          className: 'bg-blue rounded-r-lg',
        }}
      />
    </div>
  );
};

export { WorkshopProductionPreview };
